import { render, staticRenderFns } from "./addDocumetItem.vue?vue&type=template&id=72829bb0&scoped=true&"
import script from "./addDocumetItem.vue?vue&type=script&lang=js&"
export * from "./addDocumetItem.vue?vue&type=script&lang=js&"
import style0 from "./addDocumetItem.vue?vue&type=style&index=0&id=72829bb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72829bb0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72829bb0')) {
      api.createRecord('72829bb0', component.options)
    } else {
      api.reload('72829bb0', component.options)
    }
    module.hot.accept("./addDocumetItem.vue?vue&type=template&id=72829bb0&scoped=true&", function () {
      api.rerender('72829bb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customerService/components/addDocumetItem.vue"
export default component.exports